'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var IS_REDEEM_FLOW_UPDATED = 'has-redeem-flow-started:updated';

exports.IS_REDEEM_FLOW_UPDATED = IS_REDEEM_FLOW_UPDATED;
